var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Bold_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 24050",
    transform: "translate(498 260)",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-498 -260)",
    clipPath: "url(#Bold_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25231",
    d: "M510.234 281h-5.5a2.276 2.276 0 01-1.7-.534 2.4 2.4 0 01-.51-1.7v-13.531a2.356 2.356 0 01.522-1.713 2.317 2.317 0 011.688-.522h5.832a13.609 13.609 0 012.235.16 4.762 4.762 0 011.694.614 4.445 4.445 0 011.13.964 4.253 4.253 0 01.749 1.289 4.314 4.314 0 01.257 1.492 4.139 4.139 0 01-2.7 3.954q3.55 1.129 3.55 4.395a4.94 4.94 0 01-.776 2.717 4.642 4.642 0 01-2.087 1.789 7.422 7.422 0 01-1.891.485 19.268 19.268 0 01-2.493.141zm-.27-7.993h-3.794v5.255h3.917q3.7 0 3.7-2.664a2.173 2.173 0 00-.958-1.977 5.365 5.365 0 00-2.865-.614zm-3.794-7.269v4.653h3.34a6.707 6.707 0 002.106-.258 2.01 2.01 0 001.135-.981 2.213 2.213 0 00.307-1.154 1.791 1.791 0 00-.97-1.813 7.41 7.41 0 00-2.959-.448z"
  }))));
}
export default SvgBold;